import Text12 from './Text12'
export default Text12
